import { useState, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { usePageTitle } from '@/features/pageTitle';
import { PageContainer } from '@/shared/ui';
import { Tabs } from '@/shared/ui/Tabs';

import { AccountTab } from './tabs/AccountTab';
import { ClientsTab } from './tabs/ClientsTab';
import { LinksTab } from './tabs/LinksTab';
import { PayoutsTab } from './tabs/PayoutsTab';
import { RulesTab } from './tabs/RulesTab';

type TabKey = 'account' | 'clients' | 'links' | 'payouts' | 'rules';

export const AffiliatePage = (): ReactNode => {
  const { t } = useTranslation();
  usePageTitle(t('common:menu.affiliate'));

  const [tab, setTab] = useState<TabKey>('account');

  const tabsConfig: Array<{ value: TabKey; label: string; content: ReactNode }> = [
    { value: 'account', label: t('common:affiliatePage.tabs.account'), content: <AccountTab /> },
    { value: 'clients', label: t('common:affiliatePage.tabs.clients'), content: <ClientsTab /> },
    { value: 'links', label: t('common:affiliatePage.tabs.links'), content: <LinksTab /> },
    { value: 'payouts', label: t('common:affiliatePage.tabs.payouts'), content: <PayoutsTab /> },
    { value: 'rules', label: t('common:affiliatePage.tabs.rules'), content: <RulesTab /> },
  ];

  return (
    <PageContainer>
      <Tabs
        tabs={tabsConfig}
        value={tab}
        onChange={(_, v) => setTab(v as TabKey)}
      />
    </PageContainer>
  );
};
